import { render, staticRenderFns } from "./TabWrapper.vue?vue&type=template&id=728fff96&"
import script from "./TabWrapper.vue?vue&type=script&lang=ts&"
export * from "./TabWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports